export const DEV_BRAND_OVERRIDE_KEY = '__driver_v2_dev_brand_override__'
export const DEV_BRAND_QUERY_KEY = 'brand'

export type ThemeBrand = 'IYX' | 'IROK' | 'CAROTMAS'

type BrandThemeTokens = Record<string, string>

const brandThemes: Record<ThemeBrand, BrandThemeTokens> = {
  IYX: {
    '--color-brand-1': '#ff8f60',
    '--color-brand-1-rgb': '255, 143, 96',
    '--color-brand-2': '#f26e3e',
    '--color-brand-2-rgb': '242, 110, 62',
    '--brand-color': '#ff8f60',
    '--brand-color-pure': '#f26e3e',
    '--brand-color-rgb': '255, 143, 96',
    '--brand-color-pure-rgb': '242, 110, 62',
    '--brand-accent-color': '#ff8f60',
    '--brand-accent-rgb': '255, 143, 96',
    '--brand-fn-color': '#ff6b00',
    '--bg-main':
      'radial-gradient(at 0% 0%, hsla(16, 88%, 59%, 1) 0px, transparent 95%), radial-gradient(at 50% 0%, hsla(45, 93%, 65%, 1) 0px, transparent 50%), radial-gradient(at 0% 100%, hsla(20, 90%, 70%, 1) 0px, transparent 95%), radial-gradient(at 100% 100%, hsla(10, 80%, 50%, 1) 0px, transparent 80%), #f26e3e',
    '--sidebar-item-active': 'rgba(255, 247, 242, 0.88)',
  },
  IROK: {
    '--color-brand-1': '#ff8f60',
    '--color-brand-1-rgb': '255, 143, 96',
    '--color-brand-2': '#f26e3e',
    '--color-brand-2-rgb': '242, 110, 62',
    '--brand-color': '#ff8f60',
    '--brand-color-pure': '#f26e3e',
    '--brand-color-rgb': '255, 143, 96',
    '--brand-color-pure-rgb': '242, 110, 62',
    '--brand-accent-color': '#ff8f60',
    '--brand-accent-rgb': '255, 143, 96',
    '--brand-fn-color': '#ff6b00',
    '--bg-main':
      'radial-gradient(at 0% 0%, hsla(16, 88%, 59%, 1) 0px, transparent 95%), radial-gradient(at 50% 0%, hsla(45, 93%, 65%, 1) 0px, transparent 50%), radial-gradient(at 0% 100%, hsla(20, 90%, 70%, 1) 0px, transparent 95%), radial-gradient(at 100% 100%, hsla(10, 80%, 50%, 1) 0px, transparent 80%), #f26e3e',
    '--sidebar-item-active': 'rgba(255, 247, 242, 0.88)',
  },
  CAROTMAS: {
    '--color-brand-1': '#2caad2',
    '--color-brand-1-rgb': '44, 170, 210',
    '--color-brand-2': '#3f4a8f',
    '--color-brand-2-rgb': '63, 74, 143',
    '--brand-color': '#42bce3',
    '--brand-color-pure': '#2caad2',
    '--brand-color-rgb': '44, 170, 210',
    '--brand-color-pure-rgb': '44, 170, 210',
    '--brand-accent-color': '#42bce3',
    '--brand-accent-rgb': '66, 188, 227',
    '--brand-fn-color': '#c15784',
    '--bg-main':
      'radial-gradient(at 0% 0%, rgba(92, 215, 246, 1) 0px, transparent 95%), radial-gradient(at 46% 0%, rgba(86, 146, 255, 0.95) 0px, transparent 54%), radial-gradient(at 0% 100%, rgba(74, 206, 221, 0.9) 0px, transparent 92%), radial-gradient(at 100% 100%, rgba(63, 74, 143, 0.98) 0px, transparent 82%), #3f4a8f',
    '--sidebar-item-active': 'rgba(244, 249, 255, 0.9)',
  },
}

export const normalizeBrandValue = (value?: string | null): ThemeBrand | null => {
  if (!value) {
    return null
  }

  const normalized = value.trim().toUpperCase()
  if (normalized === 'IYX' || normalized === 'IROK' || normalized === 'CAROTMAS') {
    return normalized
  }

  return null
}

export const getBrandThemeTokens = (brand: ThemeBrand): BrandThemeTokens => {
  return brandThemes[brand]
}
